import { render, staticRenderFns } from "./questionnaireTopicList.vue?vue&type=template&id=31974d79&scoped=true"
import script from "./questionnaireTopicList.vue?vue&type=script&lang=js"
export * from "./questionnaireTopicList.vue?vue&type=script&lang=js"
import style0 from "./questionnaireTopicList.vue?vue&type=style&index=0&id=31974d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31974d79",
  null
  
)

export default component.exports